



































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import moment from 'moment'
    Vue.use(Preview);


    class PageOrderRequest extends PageRequest {
        //WarehouseOrderStatus?: number ;
        //WarehouseOrderPackageStatus?: number;
        orderStatus?: number;
        packageStatus?: number;
        SearchInfo: string;
        BeginTime?: Date;
        EndTime?: Date;
        PlatformType: number;
        constructor() {
            super();
            this.orderStatus = null;
            this.packageStatus = null;
            this.PlatformType = null;
        }
    }


    @Component({
        name: "frontstockorder",
    })
    export default class Orders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        get list() {
            return this.$store.state.frontstockorder.list;
        };
        get loading() {
            return this.$store.state.frontstockorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('frontstockorder/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontstockorder/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.frontstockorder.currentPage = 1;
            this.getpage();
        }
        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'frontstockorder/getAll',
                data: this.pagerequest
            });

            var _this: any = this;
            _this.$previewRefresh();
        }
        get pageSize() {
            return this.$store.state.frontstockorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.frontstockorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.frontstockorder.currentPage;
        }
        async operationData(name: any, data: any) {
            if (name == '撤销') {
                await this.$store.dispatch({
                    type: 'frontstockorder/CancleStockOrder',
                    data: { stockOrderId: data.id }
                });
                this.getpage();
            } else if (name == '标记为正常') {
                await this.$store.dispatch({
                    type: 'frontstockorder/normalOrder',
                    data: { stockOrderId: data.id }
                });
                this.getpage();
            } else if (name == '查看详情') {
                await this.$store.dispatch({
                    type: 'frontstockorder/getOrder',
                    data: { stockOrderId: data.id }
                });
                this.$store.state.frontstockorder.orderStatus = data.orderStatus;
                this.$store.state.frontstockorder.packageStatus = data.packageStatus;
                this.$router.push({ name: 'stockorderDetail' });
            }
        }

        columns = [
            {
                title: '仓储名称',
                key: 'storeName',
                width: 150,
            }, {
                title: '订单编号',
                key: 'orderNumber',
                width: 150,
            }, {
                title: '订单状态',
                width: 100,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            },
            {
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "异常图片"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '备注',
                width: 200,
                key: 'reMark',
                render: (h: any, params: any) => {
                    return h('div', [h('span', { style: { color: 'red' } }, params.row.reMark)]
                    )
                }
            },
            {
                title: '包裹基本信息',
                key: '',
                width: 250,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', ("长：" + (params.row.long == null ? "" : params.row.long) + "cm," + "宽：" + (params.row.wide == null ? "" : params.row.wide) + "cm," + "高：" + (params.row.high == null ? "" : params.row.high) + "cm")), h('h3', "体积重:" + (params.row.bulkyByClient == null ? "" : params.row.bulkyByClient)), h('h3', "重量重:" + (params.row.heavyWeight == null ? "" : params.row.heavyWeight)), h('h3', "实际计算重量:" + (params.row.weight == null ? "" : params.row.weight))])
                }
            }, {
                title: '包裹状态',
                width: 90,
                key: 'packageStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name);
                }
            },
            {
                title: '费用',
                width: 200,
                render: (h: any, params: any) => {
                    var a = "";
                    var b = "";
                    var c = "";
                    var d = "";
                    var e = "";
                    var f = "";
                    if (params.row.isPay) {
                        a = 'red';
                    }
                    else {
                        a = 'dark';
                    }
                    if (params.row.freightCost) {
                        b = 'red';
                    }
                    else {
                        b = 'dark';
                    }
                    if (params.row.extraCost) {
                        c = 'red';
                    }
                    else {
                        c = 'dark';
                    }
                    if (params.row.extraCostDescribe) {
                        d = 'red';
                    }
                    else {
                        d = 'dark';
                    }
                    if (params.row.sackTotalAmount > 0) {
                        e = 'red';
                    }
                    else {
                        e = 'dark';
                    }
                    if (params.row.skuTotalAmount > 0) {
                        f = 'red';
                    }
                    else {
                        f = 'dark';
                    }
                    return h('div', [h('h3', { style: { color: a } }, "是否支付:" + (params.row.isPay ? this.L('是') : this.L('否'))), h('h3', { style: { color: e } }, "打包袋金额:" + (params.row.sackTotalAmount == null ? "" : params.row.sackTotalAmount)), h('h3', { style: { color: f } }, "SKU金额:" + (params.row.skuTotalAmount == null ? "" : params.row.skuTotalAmount)), h('h3', { style: { color: f } }, "运费:" + (params.row.freightCost == null ? "" : params.row.freightCost))])
                }
            }, {
                title: '创建时间',
                key: 'createTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
                }
            },
            {
                title: '商品信息',
                width: 300,
                key: 'productInfos',
                render: (h: any, params: any) => {
                    var _this = this;
                    var a = "";
                    if (params.row.reMark) {
                        a = 'red';
                    }
                    else {
                        a = 'dark';
                    }
                    return h('div', [
                        h('ul', params.row.productInfos.map(item => {
                            var data = { imageGuid: item.productImgGuid, url: null };
                            this.$store.commit('expressuserinfo/getImgUrl', data);
                            var url = data.url;;

                            return h('li', {
                            }, [
                                h('img', {
                                    style: {
                                        width: "50px",
                                        height: "50px",
                                        verticalAlign: "middle"
                                    },
                                    attrs: {
                                        src: url,
                                        preview: "tp_" + item.stockOrderProductId,
                                        "preview-text": item.stockOrderProductId + "img"

                                    }
                                }), item.productName, h('font', { style: { color: "red" } }, '*'), item.count])
                        })), h('h4', { style: { color: a } }, "备注：" + (params.row.reMark == null ? "" : params.row.reMark))

                    ])

                }
            },
            {
                title: '送仓时间',
                key: 'arriveWarehouseTime',
                width: 120,
                render: (h: any, params: any) => {
                    return h('span', params.row.arriveWarehouseTime ? DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime)) : '');
                }
            },
            {
                title: '打包袋数量',
                key: 'sackNums',
                width: 80,
            },
            {
                title: '基本SKU数量',
                key: 'baseSkuNums',
                width: 80,
            },

            {
                title: '操作',
                width: 100,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var _this = this;
                    var menu = [];

                    if (params.row.orderStatus == -1) {
                        menu.push("撤销");
                    }
                    if (params.row.orderStatus == -1) {
                        menu.push("标记为正常");
                    }
                    menu.push("查看详情");
                    return h('div', [
                        h('Dropdown', {
                            props: {
                                transfer: true,
                                trigger: 'click',
                            },
                            on: {
                                'on-click': (name) => {
                                    _this.operationData(name, params.row);
                                }
                            }

                        }, [
                            h('Button',
                                {
                                    domProps: {
                                        innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                    },
                                    props: {
                                        type: 'primary',
                                    }

                                }),
                            h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                                return h('DropdownItem', { props: { name: item } }, item)
                            })
                            )]),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '68px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    if (params.row.pdfGuid && params.row.pdfGuid.length > 1) {
                                        this.$store.commit('frontstockorder/getPdf', {
                                            pdfGuid: data.pdfGuid,
                                            orderNumber: data.orderNumber
                                        });
                                    }
                                }
                            }

                        }, "查看PDF"),

                    ]);

                }
            }]
        async created() {
            //var abnormal = abp.getQueryVariable("abnormal");
            //if (abnormal && abnormal == 'true') {
            //    this.pagerequest.orderStatus = -1;
            //}
            this.searchPage();
        }
    }
